import * as yup from 'yup';
import {
  requiredMessage,
  email,
  street1,
  street2,
  city,
  state,
  zip,
  country,
  phone,
} from '../../utils/validations';
import { hasMoreThanAscii } from '../../utils/helpers';

export const billingProfileInitialValues = {
  name: '',
  apEmailAddress: '',
  contact: {
    name: '',
    emailAddress: '',
    phoneNumber: '',
    address: {
      street1: '',
      street2: '',
      city: '',
      state: '',
      province: '',
      zipcode: '',
      country: 'United States',
    },
  },
};

const addressSchema = yup.object().shape({
  street1: street1.required(requiredMessage),
  street2: street2.nullable(),
  city: city.required(requiredMessage),
  state: yup.string().when('country', {
    is: 'United States',
    then: state.required('State is required.'),
    otherwise: yup.string(),
  }),
  zipcode: zip.when('country', {
    is: 'United States',
    then: yup
      .string()
      .matches(/^[\d-]+$/, 'US zipcodes can only contain numbers and hyphens'),
    otherwise: yup.string(),
  }),
  country: country.required(requiredMessage),
});

const contactSchema = yup.object().shape({
  name: yup
    .string()
    .required('Contact Name is required.')
    .test(
      'cannot-have-first-or-last-more-than-40-chars',
      'Contact first and last must be less than 40 characters',
      (value) => {
        const fullName = value || '';
        if (fullName.length >= 80) {
          return false;
        }
        const nameArray = fullName.split(' ');
        return nameArray.every((name) => name.length <= 40);
      }
    ),
  emailAddress: email.required(requiredMessage),
  phoneNumber: phone.required(requiredMessage),
  address: addressSchema,
});

export const billingProfileSchema = yup.object().shape({
  name: yup
    .string()
    .required('Entity Name is required.')
    .test(
      'cannot-contain-ascii',
      'Entity must contain English Characters',
      (value) => {
        if (value !== undefined) {
          return !hasMoreThanAscii(value);
        } else {
          return false;
        }
      }
    )
    .max(100, 'Name cannot be longer than 100 characters.'),
  contact: contactSchema,
});
